import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { BaseComponent } from '@app/core/helperclasses/basecomponent';
import { UntilDestroy } from '@ngneat/until-destroy';
import { ThemingService } from '@app/core/helperclasses/theming.service';

@UntilDestroy()
@Component({
  selector: 'course-logo',
  templateUrl: './course-logo.component.html',
  styleUrls: ['./course-logo.style.scss'],
  host: {
    class: 'course-logo-sc',
  },
})
export class CourseLogoComponent
  extends BaseComponent
  implements AfterViewInit
{
  @Input() SrcLightMode: string = '';
  @Input() SrcDarkMode: string = '';
  @Input() shape: 'rectangle' | 'circle' = 'rectangle';
  @Input() isContained: boolean = false;
  @Input() isElevated: boolean = false;
  public logoSrc: string = '';
  public intrinsicWidthLightMode: number = 0;
  public intrinsicHeightLightMode: number = 0;
  public intrinsicWidthDarkMode: number = 0;
  public intrinsicHeightDarkMode: number = 0;

  @ViewChild('hiddenImageLightMode') hiddenImageLightMode?: ElementRef;
  @ViewChild('hiddenImageDarkMode') hiddenImageDarkMode?: ElementRef;

  constructor(public themingService: ThemingService) {
    super();
  }

  ngOnInit() {
    this.addSubscription(this.themingService.theme).subscribe((theme) => {
      if (theme !== undefined) {
        this.setLogoSrc(theme);
      }
    });
  }

  ngAfterViewInit(): void {
    this.calculateIntrinsicSize();
  }

  setLogoSrc(theme: string) {
    if (theme === 'theme-light') {
      this.logoSrc =
        this.SrcLightMode !== '' ? this.SrcLightMode : this.SrcDarkMode;
    } else {
      this.logoSrc =
        this.SrcDarkMode !== '' ? this.SrcDarkMode : this.SrcLightMode;
    }
  }

  calculateIntrinsicSize() {
    const imgLightMode = new Image();
    imgLightMode.src = this.SrcLightMode;
    imgLightMode.onload = () => {
      this.intrinsicWidthLightMode = imgLightMode.width;
      this.intrinsicHeightLightMode = imgLightMode.height;
    };

    const imgDarkMode = new Image();
    imgDarkMode.src = this.SrcDarkMode;
    imgDarkMode.onload = () => {
      this.intrinsicWidthDarkMode = imgDarkMode.width;
      this.intrinsicHeightDarkMode = imgDarkMode.height;
    };
  }
}
